import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import useFetch from "../../../hooks/useFetch";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp, faEye } from "@fortawesome/free-solid-svg-icons";

const TABS = [
  { key: "STICKY", label: "Sticky" },
  { key: "TODAY", label: "Today" },
  { key: "WEEK", label: "This Week" },
  { key: "MONTH", label: "This Month" },
];

const HAFHUpdatesList = ({ t, selectedLanguage, currentTheme }) => {
  const authState = useSelector((state) => state.authReducer);
  const [fetchData] = useFetch();
    const isLoggedIn = authState?.isLoggedIn || false;
    const userId = authState._id || null;
    const userCode = authState.think5whyscode || "";

  const [activeTab, setActiveTab] = useState("STICKY");
  const [dataCache, setDataCache] = useState({
    STICKY: [],
    TODAY: [],
    WEEK: [],
    MONTH: [],
  });

  const [expanded, setExpanded] = useState({});

  const fetchUpdates = async (tab) => {
    setDataCache((prev) => {
        if (prev[tab]?.length > 0) return prev;
        return prev;
    });

    try {
        const res = await fetchData({
        url: "/hafh/operations/updates/list",
        method: "post",
        data: { tab },
        headers: { Authorization: authState.token },
        });

        // console.log("API RESPONSE:", res);

        if (res?.status) {
        setDataCache((prev) => ({
            ...prev,
            [tab]: res.records || [],
        }));
        }

    } catch (err) {
        console.error("FETCH ERROR:", err?.response?.data || err.message || err);
    }
  };

  useEffect(() => {
    if (authState?.token && userCode) {
      fetchUpdates("STICKY");
    }
  }, [authState?.token, userCode]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    fetchUpdates(tab);   
    };

  const toggleExpand = (id) => {
    setExpanded((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

const renderList = () => {
    const list = dataCache[activeTab] || [];

    if (!list.length) {
      return (
        <div className={`${currentTheme.subText} text-center mt-10`}>
          No updates available
        </div>
      );
    }

    return list.map((item) => (
      <div
        key={item._id}
        className={`
          ${currentTheme.card}
          border
          ${currentTheme.border}
          rounded-xl
          p-4 mb-3
          shadow-sm
        `}
      >
        <div className={`flex justify-between items-center text-xs ${currentTheme.subText}`}>
          <span>
            {item.postedBy || "Admin"} •{" "}
            {new Date(item.updateDate).toLocaleDateString()}
          </span>

          <button onClick={() => toggleExpand(item._id)}>
            <FontAwesomeIcon
              icon={expanded[item._id] ? faChevronUp : faChevronDown}
            />
          </button>
        </div>

        <div className={`font-semibold mt-2 ${currentTheme.text}`}>
          {item.headline}
        </div>
        {expanded[item._id] && (
          <div className={`text-sm mt-2 whitespace-pre-line ${currentTheme.subText}`}>
            {item.details}
          </div>
        )}

      </div>
    ));
  };


  return (
    <div className={`${currentTheme.bg} ${currentTheme.text} w-full p-3`}>
      <div className="grid grid-cols-4 gap-2 mb-4">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            onClick={() => handleTabChange(tab.key)}
            className={`
              text-xs md:text-sm
              py-2 rounded-lg border
              transition-all duration-200

              ${
                activeTab === tab.key
                  ? currentTheme.tabActive
                  : `${currentTheme.tabInactive} ${currentTheme.tabHover}`
              }
            `}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {renderList()}
    </div>
  );
};

export default HAFHUpdatesList;